<nb-card>
    <nb-card-header class="d-flex pb-0 pe-3">
      <morva-icons icon="warning"></morva-icons>
      <span class="text me-1">هشدار</span>
    </nb-card-header>
    <nb-card-body>
      <p class="text m-0">{{messageOne}}</p>
      <p class="text m-0">
        {{messageTwo}}
      </p>
      <div
        class="
          nb-card-footer
          d-flex
          align-items-center
          justify-content-center
        "
      >
        <button
        data-testid="confirm-button"
          nbButton
          nbSpinnerStatus="basic"
          class="confirm-button"
          (click)="continue()"
        >
          تایید
        </button>
      </div>
    </nb-card-body>
  </nb-card>
  